import { createFileRoute } from "@tanstack/react-router";
import SitePage from "@/components/SitePage";
import { buildHead, breadcrumbLD, touristTripLD, faqLD, SITE_URL } from "@/content/seo";

const TITLE = "Cruzeiro de Pedido de Casamento em Vilamoura · Iate Privado · Morningstar";
const DESC = "Faça o pedido de casamento no mar em Vilamoura no Morningstar — iate privado ao pôr-do-sol, Champagne, fotógrafo opcional, pétalas de rosa e um momento coordenado no Algarve.";
const PATH = "/pt/cruzeiro-pedido-casamento-vilamoura";
const URL = `${SITE_URL}${PATH}`;

export const Route = createFileRoute("/pt/cruzeiro-pedido-casamento-vilamoura")({
  component: () => (
    <SitePage
      lang="pt"
      heroOverride={{
        eyebrow: "Pedido de Casamento · Vilamoura · Algarve",
        title: "Faça o pedido de casamento no mar em Vilamoura no ",
        titleAccent: "Morningstar.",
        sub: "Pôr-do-sol privado, Champagne no gelo, fotógrafo opcional e um capitão que sabe exatamente quando abrandar o barco. Coreografamos o momento, vocês vivem-no.",
        ctaPrimary: "Ver cruzeiros",
        ctaSecondary: "Planear o meu pedido",
      }}
    />
  ),
  head: () =>
    buildHead({
      lang: "pt",
      path: PATH,
      title: TITLE,
      description: DESC,
      keywords: "pedido casamento barco vilamoura, pedido de casamento algarve, noivado barco vilamoura, romântico barco algarve",
      altPath: { en: "/proposal-cruise-vilamoura", pt: PATH },
      extraScripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            touristTripLD({
              name: "Vilamoura Proposal Cruise",
              description: DESC,
              url: URL,
            }),
          ),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify(
            breadcrumbLD([
              { name: "Início", path: "/pt" },
              { name: "Pedido de Casamento Vilamoura", path: PATH },
            ]),
          ),
        },
        { type: "application/ld+json", children: JSON.stringify(faqLD("pt")) },
      ],
    }),
});
